<mat-toolbar >

  <span routerLink='' >

    Blog App
  </span>
  <span class="example-spacer"></span>
  <button *ngIf="!is_loggedin" routerLink='/register' mat-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
    <mat-icon>
      how_to_reg
    </mat-icon>
    join with us
  </button>
  <button *ngIf="!is_loggedin" routerLink='/login' mat-button class="example-icon" aria-label="Example icon-button with share icon">
    <mat-icon>
      login
    </mat-icon>
    login
  </button>
  <button *ngIf="is_loggedin" (click)="logout()" routerLink='login' mat-button class="example-icon" aria-label="Example icon-button with share icon">
    <mat-icon>
      logout
    </mat-icon>
    logout
  </button>
</mat-toolbar>
